module.exports = __webpack_public_path__ + "static/media/plus.146be2d4.svg";